/**
 * Created by Ninghai on 2017/12/19.
 */
import {
  TEST_MUTATION,
  JOB_LIST,
  CHANGE_USER_STATUS,
  SET_USER_MESSAGE,
  SET_GLOBAL_MESSAGE,
  CHANGE_LOADING_STATE,
  CLEAN_COMPANY_LIST,
  ADD_COMPANY_LIST,
  SET_NEXT_TARGET_COMPANY,
  SET_NEXT_PURCHASE,
  SET_UNLISTED_COMPANY_DATA_DATE,
  SET_NODATA_LAYER_STATUS,
  SET_WECHAT_PAY_COUNT,
  SET_WECHAT_PAY_ORDER,
  SET_WHITE_LIST,
  SET_DEFAULT_ACTIVE_ENTERPRISE,
  SET_STRCTURE_MATRIX,
  SET_API_ACTIVE_LINK,
  SET_LOADING_ANIMATION_STATUS,
  REMOVE_CHART,
  ADD_CHART,
  CLEAR_CHART,
  CHANGE_INDEX,
  FACTOR_TYPE,
  EMOTION_DETAILS,
  STOCK_DETAILS,
  LEFT_LOADING,
  RIGHT_LOADING,
  RETAILERS,
  RETAILERS_TOP,
  SHOW_REPORT,
  DATE_TYPE,
  DATE_TYPE_LIVE,
  LIVE_DATA,
  BRAND_DATA,//品牌馆
  // TMALL_DATA,//15万天猫
} from './mutation-types'
import {messageExpireTime, productTypes} from '../utils/constant'

export default {
  [TEST_MUTATION] (state, payload) {
    state.count += payload.count
  },
  [JOB_LIST] (state, list) {
    state.jobList = list
  },
  [CHANGE_USER_STATUS] (state, isLogon) {
    state.hasLogin = isLogon
  },
  [SET_USER_MESSAGE] (state, {user_id, token, username}) {
    // eslint-disable-next-line
    state.user_id = user_id
    state.token = token
    state.username = username
  },
  [SET_GLOBAL_MESSAGE] (state, {type, title, content}, expire) {
    let expireTime = expire || messageExpireTime
    state.showMessage = true
    state.globalMessage = {type, title, content}
    setTimeout(() => {
      state.showMessage = false
      state.globalMessage = {}
    }, expireTime)
  },
  [CHANGE_LOADING_STATE] (state, isLoading) {
    state.isLoading = isLoading
  },
  [CLEAN_COMPANY_LIST] (state) {
    state.companyList.length = 0
  },
  [ADD_COMPANY_LIST] (state, enterpriseList) {
    let list = state.companyList
    list.push.apply(list, enterpriseList)
  },
  [SET_NEXT_TARGET_COMPANY] (state, nextCompany) {
    state.nextTargetCompany = nextCompany
  },
  [SET_NEXT_PURCHASE] (state, type, id, renewable) {
    if (productTypes.indexOf(type) < 0) {
      state.nextPurchaseTarget.renewable = false
      state.nextPurchaseTarget.id = undefined
      state.nextPurchaseTarget.type = 'unlisted'
    } else {
      state.nextPurchaseTarget.renewable = renewable
      state.nextPurchaseTarget.id = id
      state.nextPurchaseTarget.type = type
    }
  },
  [SET_UNLISTED_COMPANY_DATA_DATE] (state, date) {
    state.unlistedCompanyDataDate = date
  },
  [SET_NODATA_LAYER_STATUS] (state, status) {
    state.isNoData = status
  },
  [SET_WECHAT_PAY_COUNT] (state, count) {
    state.weChatCount = count
  },
  [SET_WECHAT_PAY_ORDER] (state, order) {
    state.orderId = order
  },
  [SET_WHITE_LIST] (state, list) {
    state.whiteList = list
  },
  [SET_DEFAULT_ACTIVE_ENTERPRISE] (state, industryEnterprise) {
    state.defaultActiveIndex = industryEnterprise
  },
  [SET_STRCTURE_MATRIX] (state, strcture) {
    state.strctureMatrix = strcture
  },
  [SET_API_ACTIVE_LINK] (state, link) {
    state.defaultActiveApiLink = link
  },
  [SET_LOADING_ANIMATION_STATUS] (state, key) {
    state.showLoadingAnimation = key
  },
  [REMOVE_CHART] (state, id) {
    state.charts[id] = null
  },
  [ADD_CHART] (state, chartObj) {
    state.charts[chartObj.id] = chartObj.chart
  },
  [CLEAR_CHART] (state) {
    for (let id in state.charts) {
      state.charts[id] = null
    }
  },
  [CHANGE_INDEX] (state, status) {
    state.showNewIndex = status
  },
  [FACTOR_TYPE] (state, res) {
    state.emotionObject.individualStock = res
  },
  [EMOTION_DETAILS] (state, res) {
    state.emotionObject.stockRainkList = res
  },
  [STOCK_DETAILS] (state, res) {
    state.emotionObject.singleRockList = res
  },
  [LEFT_LOADING] (state, payload) {
    state.emotionObject.loading.leftLoading = payload
  },
  [RIGHT_LOADING] (state, payload) {
    state.emotionObject.loading.rightLoading = payload
  },
  [RETAILERS] (state, payload) {
    state.retailersObject = payload
  },
  [SHOW_REPORT] (state, payload) {
    state.showReport = payload
  },
  [DATE_TYPE] (state, payload) {
    state.dateType = payload
  },
  [RETAILERS_TOP] (state, payload) {
    state.retailersObject2 = payload
  },
  [DATE_TYPE_LIVE] (state,payload) {
    state.dateTypeLive = payload
  },
  [LIVE_DATA] (state,payload) {
    state.liveData = payload
  },
  //品牌馆
  [BRAND_DATA](state,payload){
    state.brandObject = payload
  },

  //15万天猫
  // [TMALL_DATA](state,payload){

  // }

}



// WEBPACK FOOTER //
// ./src/store/mutations.js